// GENERATED FILE, DO NOT EDIT
import { MyBaseCL } from "../MyBaseCL";
import { CalendarItem } from "../CommonTypes";
export class CalCL extends MyBaseCL {
	constructor(url:string="/cl/cal") { super(url); }
	public getPlannedDates(repeating: any, count: number, dateTime: any|string|any|null = null) : Promise<any> { return this.callMethod("getPlannedDates", arguments, {"rawResult":false}); }
	public getCalOverview(period: number) : Promise<{items:CalendarItem[],manyResults:boolean}> { return this.callMethod("getCalOverview", arguments, {"rawResult":false}); }
	public searchInCalendar(dtFrom: string, dtTo: string, fulltext: string) : Promise<{items:CalendarItem[],manyResults:boolean}> { return this.callMethod("searchInCalendar", arguments, {"rawResult":false}); }
}
